import { Request,BaseApiUrl } from "./api";

// 列表
export const getMaterialListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/Material/get`, { params: params });
};


//新增
export const addMaterial = (params) => {
  return Request.post(`${BaseApiUrl}/api/Material/Post`, params);
};
//编辑
export const editMaterial = (params) => {
  return Request.post(`${BaseApiUrl}/api/Material/Put`, params);
};


//批量删除
export const batchDeleteMaterial = (params) => {
  return Request.post(`${BaseApiUrl}/api/Material/BatchDelete`, params);
};
// export const batchDeleteMaterial = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/Material/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
